import React, { useState, useEffect } from "react";
import Section from "../Section";
import { Projects } from "../../Data/Data";

import image2 from "../../assest/Nikea/images/image2.jpeg";
import { NikeaApartmentRenders } from "../../assest/Nikea/floorRenders/paths";

const AboutSection = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    // Handle scroll event for image movement
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Section bg="bg-inherit">
      <div className="col-span-12 row-span-1 grid grid-cols-12 gap-x-[21px] gap-y-0 items-start flex-wrap auto-cols-fr grid-rows-auto justify-between relative text-primary-dark ">
        <div className="col-span-full md:col-start-2 md:col-end-7 flex flex-col items-start gap-2 xl:gap-y-[21px] relative py-12 xl:py-24 px-4 md:px-22 xl:px-4 text-primary-bg-blue ">
          <div
            data-v-c83bd4c6=""
            id="w-node-_888c4327-4200-3a3b-ab9a-34b87963f293-0a6b3cff"
            data-scroll=""
            className=" col-span-full xl:col-span-4 xl:row-span-1 overflow-hidden w-fit "
          >
            <img
              src={image2}
              loading="lazy"
              alt="green home project"
              className="w-full xl:w-3/5 h-auto object-cover rounded-3xl"
            />
          </div>
          <h2 className="text-2xl sm:text-4xl font-gilroy tracking-[7.14px] leading-none uppercase">
            {Projects[1].label}
          </h2>

          <div className="text-lg">{Projects[1].description}</div>
        </div>
        {/* Moving Image */}
        <div
          className="hidden md:block md:col-span-5 md:row-span-full self-center md:col-start-7 md:col-end-12 relative transform rounded-3xl"
          style={{
            transform: `translateY(${scrollY * 0.08}px)`,
            transition: "transform 1s",
          }}
        >
          <img
            src={[NikeaApartmentRenders[100.2]]}
            alt="About"
            className="rounded-3xl"
          />
        </div>
      </div>
    </Section>
  );
};

export default AboutSection;
